import type { FeatureAdoptionData } from 'shared/services/feature-adoption';

export const enum FeatureAdoptionTypes {
  ScalePrinted = 1,
  handoff,
}

export type AdoptionData = FeatureAdoptionData<FeatureAdoptionTypes>;
